import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function fmtDate(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" }); }
  catch { return iso; }
}

function download(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function safeFilename(name) {
  return (name || "graduates").replace(/[^a-z0-9]+/gi, "-").replace(/^-|-$/g, "").toLowerCase();
}

export function exportGraduatesCSV(rows, institution) {
  const header = ["Certificate ID", "Graduate Name", "Degree", "Major", "Graduation Date", "GPA", "Honors", "Issued On"];
  // Neutralize spreadsheet formula injection: any cell starting with =, +, -, @, tab, or CR
  // gets a leading single-quote so Excel/Sheets treat it as literal text.
  const FORMULA_CHARS = new Set(["=", "+", "-", "@", "\t", "\r"]);
  const neutralize = (v) => {
    if (v == null) return "";
    const s = String(v);
    if (s.length > 0 && FORMULA_CHARS.has(s[0])) return "'" + s;
    return s;
  };
  const escape = (v) => {
    const s = neutralize(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [header.join(",")];
  rows.forEach((r) => {
    lines.push([
      r.certificate_id,
      r.graduate_name,
      r.degree,
      r.major,
      fmtDate(r.graduation_date),
      r.gpa || "",
      r.honors || "",
      fmtDate(r.created_at),
    ].map(escape).join(","));
  });
  const blob = new Blob(["\uFEFF" + lines.join("\n")], { type: "text/csv;charset=utf-8" });
  download(blob, `${safeFilename(institution?.name)}-graduates-${new Date().toISOString().slice(0, 10)}.csv`);
}

export function exportGraduatesPDF(rows, institution) {
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const title = institution?.name ? `${institution.name} — Graduate Registry` : "Graduate Registry";
  const subtitle = `Total graduates: ${rows.length} · Generated ${new Date().toLocaleString()}`;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(title, 14, 15);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(100);
  doc.text(subtitle, 14, 21);
  doc.setTextColor(0);

  autoTable(doc, {
    startY: 26,
    head: [["Certificate ID", "Graduate Name", "Degree", "Major", "Graduation", "GPA", "Honors"]],
    body: rows.map((r) => [
      r.certificate_id,
      r.graduate_name,
      r.degree,
      r.major,
      fmtDate(r.graduation_date),
      r.gpa || "—",
      r.honors || "—",
    ]),
    styles: { fontSize: 9, cellPadding: 2.5 },
    headStyles: { fillColor: [15, 23, 42], textColor: 255, fontStyle: "bold" },
    alternateRowStyles: { fillColor: [248, 250, 252] },
    columnStyles: {
      0: { fontStyle: "bold", cellWidth: 34 },
      1: { cellWidth: 50 },
      2: { cellWidth: 45 },
      3: { cellWidth: 45 },
      4: { cellWidth: 26 },
      5: { cellWidth: 16 },
      6: { cellWidth: 40 },
    },
    didDrawPage: () => {
      const pageCount = doc.internal.getNumberOfPages();
      const pageNum = doc.internal.getCurrentPageInfo().pageNumber;
      doc.setFontSize(8);
      doc.setTextColor(120);
      doc.text(`CertiSeal · Your Trusted Academic Proof.`, 14, doc.internal.pageSize.getHeight() - 6);
      doc.text(`Page ${pageNum} / ${pageCount}`, doc.internal.pageSize.getWidth() - 30, doc.internal.pageSize.getHeight() - 6);
    },
  });

  doc.save(`${safeFilename(institution?.name)}-graduates-${new Date().toISOString().slice(0, 10)}.pdf`);
}
